import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const SearchProductsQuery = gql`
  query ($searchQuery: String!, $variantIds: [String!]) {
    searchAccessories(
      where: {
        variantIds: $variantIds,
        searchQuery: $searchQuery
      }
    ) {
      edges {
        node {
          id
          title
          name
          sku
          prices {
            id
            currencyId
            priceWithout
            recommendedPriceWithout
          }
          variants {
            id
            ean
            sku
            attributeValues {
              id
              title
              attribute {
                id
                isVisual
              }
            }
          }
          images {
            id
            file
            values {
              id
              attribute {
                id
                isVisual
              }
            }
          }
          availabilityId
        }
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  variantIds?: string[];
  searchQuery: string;
}

interface Response {
  data: any;
}

class SearchProductAccessories extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { products }: any = this.props;
    return this.props.children({ products });
  }
}

export default compose(
  graphql<IInputProps, Response>(SearchProductsQuery, {
    name: 'products',
    options: props => ({ 
      variables: {
        variantIds: props.variantIds || null,
        searchQuery: props.searchQuery || '',
      } 
    })
  })
)(SearchProductAccessories);



// WEBPACK FOOTER //
// ./src/components/Query/Products/SearchProductAccessories.tsx